import React from 'react';
import { MotionImage, MotionLink, FadeInSection } from '../ui/MotionPrimitives';

const AboutCta: React.FC = () => {
  return (
    <FadeInSection className="relative w-full overflow-hidden">
      <div className="relative h-[560px] w-full sm:h-[600px]">
        <MotionImage
          src="/images/pics/cta.jpg"
          alt="Hogar Dorado House call to action"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="relative z-10 flex h-full items-center justify-center px-4 lg:justify-end">
          <div className="w-full max-w-5xl text-center text-white lg:max-w-xl lg:text-left">
            <h2 className="text-3xl font-semibold tracking-tight text-[rgb(216,133,70)] sm:text-4xl lg:text-5xl">
              Discover your next investment home
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-black sm:text-lg">
              Explore a curated portfolio of premium properties across the UAE and USA, selected
              for long-term value, strong fundamentals, and lifestyle potential.
            </p>
            <div className="mt-6 flex justify-center lg:justify-start">
              <MotionLink
                to="/properties"
                className="inline-flex items-center rounded-full bg-[#D88546] px-8 py-3 text-sm font-semibold uppercase tracking-wide text-black shadow-md transition hover:bg-[#c1733d] focus:outline-none focus:ring-2 focus:ring-[#D88546] focus:ring-offset-2"
              >
                View Properties
              </MotionLink>
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default AboutCta;
